// extracted by mini-css-extract-plugin
export default {"modalOverlay":"tE-z","modalContent":"uE-z","header":"vE-z","close":"wE-z"};